export const basicurl= "https://patient.cholesterol.docsun.health";
export const backurl= "https://patient.basic.docsun.health";